export default {
    methods: {
        trackEvent({ payload }) {
			let dataForTrackEvent = { 
				isItForImagePreview: false,
                actionName: "TRACK_EVENT",
				payload
			}
			this.sendMessageToParentWindowAboutNotifications(dataForTrackEvent)
        },
    }

}